import React, { useEffect, useState } from "react";
 
import { deleteRoom, getRoomsForHostel } from "../../../services/OrganisationServices/hostelRoomServices";
import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { useParams } from "react-router-dom";
import { useGlobalState } from "../../../services/hostelConst.js";
import RoomManagementForm from "./add-room-to-hostel";
import { getHostelApplicationList, getRejectedHostelApplicationList } from "../../../services/OrganisationServices/hostelManagmentService";
const RejectedHostelApplicationTable = ({ hostelId }) => {
  const { hostelMenuState, toggleHostelMenu } = useGlobalState();
  var { id} = useParams();
  useEffect(() => {
    toggleHostelMenu(true);

    return () => {};
  }, []);

  return (
    <div>
      <MasterTable
        getTableData={getRejectedHostelApplicationList}
        tab1={"Hostel"}
        tab2={"Rejected"}
        hostelId={id}
        externalPermis={{
            POST: 0,
            GET: 1,
            PUT: 0,
            DELETE: 0,
            PATCH: 0,
          }}
      />
    </div>
  );
};

export default RejectedHostelApplicationTable;
